import { Component, Input, OnInit } from '@angular/core';
import { Entry } from 'contentful';
import { FunctionalCapabilitiesDisruptionHandlingPage } from 'src/app/model/page/group/api-docs/functional-capabilities-disruption-handling-page';
import { ContentfulService } from 'src/app/service/contentful.service';
import { SharedDataService } from 'src/app/service/shared-data.service';
import { ModelValidator } from 'src/app/validator/model-validator';
import htmlTitle from 'src/assets/json/redirects/html-title.json';

@Component({
  selector: 'app-functional-capabilities-disruption-handling-page',
  templateUrl: './functional-capabilities-disruption-handling-page.component.html',
  styleUrls: ['./functional-capabilities-disruption-handling-page.component.scss']
})
export class FunctionalCapabilitiesDisruptionHandlingPageComponent implements OnInit {
  @Input() apiName: string = '';
  @Input() apiTabs: string[] = [];
  @Input() apiTabsClass: string[] = [];
  @Input() pageTitle: string = '';
  @Input() isTab: boolean = false;
  @Input() href: string = '';
  @Input() isTabOverride: boolean = false;
  @Input() selectedIndex: number = 0;

  public group = '';
  functionalCapabilitiesDisruptionHandlingPage: FunctionalCapabilitiesDisruptionHandlingPage = {} as FunctionalCapabilitiesDisruptionHandlingPage;

  category: any;

  constructor(private contentfulService: ContentfulService, private sharedDataService: SharedDataService) {}

  ngOnInitWithPageTitle(pageTitle: string) {
    // console.log('>>>> >>>> FunctionalCapabilitiesDisruptionHandlingPageComponent invoked ngOnInitWithPageTitle');

    this.selectedIndex = 0;
    this.setPageTitle(pageTitle);
  }

  setPageTitle(value: string) {
    // console.log(value);

    if (value.length > 0) {
      this.pageTitle = value;
    }

    this.ngOnInit();
  }

  ngOnInit(): void {
    htmlTitle.filter((title) => {
      if (title.page === 'functional-capabilities-disruption-handling') {
        this.functionalCapabilitiesDisruptionHandlingPage.htmlTitle = title.htmlTitle;
      }
    });
    // console.log('apiName : ' + this.apiName);
    // console.log('pageTitle : ' + this.pageTitle);
    const query = { 'fields.title': this.pageTitle, include: 2 };
    this.functionalCapabilitiesDisruptionHandlingPage.introductionSections = [];
    this.functionalCapabilitiesDisruptionHandlingPage.ribbonTileSections = [];
    this.functionalCapabilitiesDisruptionHandlingPage.sectionBelowRibbonTile = [];
    this.functionalCapabilitiesDisruptionHandlingPage.sections = [];

    this.contentfulService.getPageContentResponse(query).then((disruptionHandlingPageEntries) => {
      this.mapBanner(disruptionHandlingPageEntries.includes.Entry);
      this.sharedDataService.addSharedData(this.functionalCapabilitiesDisruptionHandlingPage.banner);
      this.mapSection(disruptionHandlingPageEntries.includes.Entry);
      this.mapPageInfo(disruptionHandlingPageEntries.items);
    });
  }

  private mapBanner(disruptionHandlingPageEntries: Entry<any>[]) {
    disruptionHandlingPageEntries
      .filter((entry) => ModelValidator.isBanner(entry))
      .forEach((entry) => {
        this.mapEntryToBanner(entry);
      });
  }

  private mapEntryToBanner(entry: Entry<any>) {
    let imageDetails: any = entry.fields['image'];
    let videoDetails: any = entry.fields['video'];
    this.functionalCapabilitiesDisruptionHandlingPage.banner = {
      title: entry.fields['title'] as string,
      subTitle: entry.fields['subTitle'] as string,
      image: imageDetails.fields.file.url as string,
      video: videoDetails?.fields?.file?.url  as string
    };
  }
  private mapSection(offerManagementPageSectionEntry: Entry<any>[]) {
    offerManagementPageSectionEntry
      .filter((entry) => ModelValidator.isSection(entry))
      .forEach((entry) => {
        switch (entry.fields['group']) {
          case 'introduction':
            this.mapEntryToSection(entry);
            break;
          case 'ribbon-tile':
            this.mapEntryToRibbonTileSection(entry);
            break;
          case 'ribbon-tile-saw-tooth-vertical':
            this.mapEntryToRibbonTileSection(entry);
            break;
          case 'section-below-ribbon-tile':
            this.mapEntryToSectionBelowRibbonTile(entry);
            break;
          default:
            console.error('New group Found - ' + entry.fields['title']);
            break;
        }
      });
  }

  private mapEntryToSection(entry: Entry<any>) {
    this.functionalCapabilitiesDisruptionHandlingPage.introductionSections.push({
      title: '',
      body: entry.fields['body']  as string,
      group: entry.fields['group']  as string,
      order: entry.fields['order']  as number,
      heading: entry.fields['heading']  as string
    });
    this.functionalCapabilitiesDisruptionHandlingPage.introductionSections.sort((a, b) => a.order - b.order);
  }

  private mapEntryToSectionBelowRibbonTile(entry: Entry<any>) {
    this.functionalCapabilitiesDisruptionHandlingPage.sectionBelowRibbonTile.push({
      title: entry.fields['title'] as string,
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number,
      heading: entry.fields['heading'] as string
    });
    this.functionalCapabilitiesDisruptionHandlingPage.sectionBelowRibbonTile.sort((a, b) => a.order - b.order);
  }

  private mapEntryToRibbonTileSection(entry: Entry<any>) {
    let tBody: string[] = [];
    let pageBody=entry.fields['body'] as string;
    pageBody.split('@').forEach((apiArrow: any) => {
      if (apiArrow !== '') {
        tBody.push(apiArrow);
      }
    });
    let givenTitle:any=entry.fields['title'] as string;
    let pageTitle=givenTitle.split('#').pop();
    
    this.functionalCapabilitiesDisruptionHandlingPage.ribbonTileSections.push({
      title: pageTitle.split('#').pop(),
      body: '',
      bodyArrows: tBody,
      order: entry.fields['order'] as number,
      group: entry.fields['group'] as string,
      heading: entry.fields['heading'] as string,
      subBody: entry.fields['subBody'] as string,
      sectionClass: entry.fields['sectionClass'] as string
    });
    this.group = entry.fields['group'] as string;
    this.category = entry.fields['category'];
    this.functionalCapabilitiesDisruptionHandlingPage.ribbonTileSections.sort((a, b) => a.order - b.order);
  }

  private mapPageInfo(items: Entry<any>[]) {
    items.forEach((entry: any) => {
      let editorDetails = entry.fields?.editorDetails?.split('#');
      this.functionalCapabilitiesDisruptionHandlingPage.banner.lastUpdated = entry.fields?.lastUpdated;
      this.functionalCapabilitiesDisruptionHandlingPage.banner.url = entry.fields?.url;
      this.functionalCapabilitiesDisruptionHandlingPage.banner.editorEmail = editorDetails?.pop();
      this.functionalCapabilitiesDisruptionHandlingPage.banner.editorShortName = editorDetails?.pop();
      this.functionalCapabilitiesDisruptionHandlingPage.banner.editorFullName = editorDetails?.pop();
      this.functionalCapabilitiesDisruptionHandlingPage.htmlTitle = entry.fields.htmlTitle;
    });
  }
}
